import React, { useEffect, useState, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import tenantService from "../../service/tenant";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import InviteUser from "./inviteUser";
import { convertCamelCase, parseResponse } from "../../utilities/utillFunction";
import ConfigService from "../../service/configService";
import { Messages } from "primereact/messages";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { plazaServices } from "./../tollPlaza/plazaReportService";
import { useSelector, useDispatch } from "react-redux";
import service from "../../service/apiService";
import imagineHomeService from "../imagineHome/imagineHomeService";
import { designerAdmin } from "../../lib/constants";

import * as XLSX from "xlsx";

const ManageUsers = () => {
    const serviceId = localStorage.getItem("serviceId");
    let nqpermissions = JSON.parse(localStorage.getItem("permissions"));
    let writeAccess = nqpermissions.find((p) => p === "UserManagement.WRITE");
    const [users, setUsers] = useState([]);
    const [vendors, setVendors] = useState([]);

    const [displayDailog, setDialogDisplay] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [countryList, setCountryList] = useState([]);

    const [searchText, setSearchText] = useState("");
    const [selectedUserType, setSelectedUserType] = useState("");
    const [displayDeleteWarningDialog, setDeleteWarningDialogVisible] = useState(null);
    const [displayResendInviteDialog, setResendInviteDialogVisible] = useState(null);
    const [notVerifiedUser, setNotVerifiedUser] = useState(false);

    const [customers, setCustomers] = useState([]);
    const [assignedCustomerWarningDialog, setAssignedCustomerWarningDialogVisible] = useState(null);
    const [deletionSubmitted, setDeletionSubmitted] = useState(false);

    const { allVendors } = useSelector((state) => state.usersVendors);
    const dispatch = useDispatch();

    const userTypeOptions = [
        { label: "Designer", value: "ihdesigner" },
        { label: "Customer", value: "ihcustomer" },
    ];

    const [first, setFirst] = useState(0);
    const [skip, setSkip] = useState(0);
    const isInitialRender = useRef(true);
    const [loading, setLoading] = useState(true);
    const [tradePartners, setTradePartners] = useState([]);
    const [resetKey, setResetKey] = useState(0);
    const [orgId, setOrgId] = useState(localStorage.getItem("orgId") || null);
    
    const isDesignerAdmin = nqpermissions.includes(designerAdmin)

    const fetchPartnerListsData = async (searchQuery = "") => {
        try {
            const res = await imagineHomeService.getTradePartnerListsData({
                serviceId: serviceId,
                skip: 0,
                limit: 0,
                searchQuery: searchQuery,
            });

            console.log(res);

            if (res.responseCode === 200) {
                setTradePartners(res.responseData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const usersLimit = 20,
        rows = 10;

    const message = useRef();
    const toast = useRef();
    const serviceData = JSON.parse(localStorage.getItem("service"));
    const imageBodyTemplate = (thing) => {
        return <img alt="" src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(thing.image)} onError={(e) => (e.target.src = "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")} style={{ maxWidth: "100%", maxHeight: "30px" }} />;
    };

    useEffect(() => {
        getUsers(makeQuery(0, usersLimit));
        fetchPartnerListsData();
    }, []);


    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            setFirst(0);
            setSkip(0);
            setUsers([]);
            handleFilter(0);
        }, 1000);

        return () => clearTimeout(timer); // Cleanup to avoid multiple calls
    }, [searchText, selectedUserType, notVerifiedUser, resetKey]);

    const makeQuery = (skip = 0, limit = 0) => {
        const query = {
            serviceId,
            skip,
            limit,
            searchQuery: searchText,
            userType: selectedUserType,
            onlyUnverified: notVerifiedUser,
            populate: "user.org",
            orgId: isDesignerAdmin ? orgId :undefined
        };
        return query;
    };

    const handleFilter = async (skipCount = 0) => {
        try {
            setLoading(true);
            let resp = await tenantService.getUsers(makeQuery(skipCount, usersLimit));
            if (!resp || resp.responseCode !== 200) {
                message?.current?.show({ severity: "error", content: resp?.message ?? "Something wents wrong" });
                return;
            }
            // avoid duplicating users
            // const mergedUsers = [...existingUser, ...resp.responseData.filter((newU) => !existingUser.some((oldU) => oldU._id === newU._id))];
            // setUsers(mergedUsers);
            if (resp.responseData.length < usersLimit) setSkip(-1);
            setUsers((prev) => {
                const merged = [...prev, ...resp.responseData];
                return merged;
            });
        } catch (error) {
            console.error("Error fetching filtered data:", error);
        } finally {
            setLoading(false);
        }
    };
    const getUsers = async (query) => {
        setLoading(true);

        if(!orgId)
        {
            // fetch current user's orgId
            let nqPayload = { "filter": { "serviceId": serviceId, "user.role": "ihdesigner",$or: [{ "user.disabledUser": { $exists: false } },{ "user.disabledUser": false }] } }
             service
            .httpDBService(nqPayload, serviceId, "nq-customer-project-designer-mappings")
            .then((res) => {
                localStorage.setItem("orgId", res.user.orgId)
                setOrgId(res.user.orgId);
            })
            .catch((e) => {
                console.log(e);
                message?.current?.show({ severity: "error", content: resp?.message ?? "Something went wrong" });
                setLoading(false);
                return;
            });
        }
        let resp = await tenantService.getUsers(query);

        if (!resp || resp.responseCode !== 200) {
            message?.current?.show({ severity: "error", content: resp?.message ?? "Something went wrong" });
            setLoading(false);
            return;
        }
        setUsers(resp.responseData);
        setLoading(false);
        if (!allVendors.length) {
            await getVendors();
        } else {
            setVendors(allVendors);
        }
        // await getCountryList();

        // get customers list
        service
            .httpDBService({}, serviceId, "nq-customer-project-designer-mappings")
            .then((res) => {
                setCustomers(res);
            })
            .catch((e) => {
                console.log(e);
            });
    };
    const getVendors = async () => {
        const vendorResponse = await plazaServices.general(serviceId, {}, "nq-products-vendors");
        setVendors(vendorResponse ?? []);
        dispatch({ type: "SET_ALL_VENDORS", payload: vendorResponse });
    };

    const getCountryList = async () => {
        let [error, countryList] = await parseResponse(ConfigService.getCountryList());
        if (error) {
            message?.current?.show({ severity: "error", content: "Something wents wrong" });
            return;
        }

        let countries = [];
        countryList.forEach((c) => {
            countries.push({ name: convertCamelCase(c), value: c });
        });

        setCountryList(countries);
    };

    const showPermissions = (row) => {
        return (
            <div className="bodyStyle">
                {row.permissions && row.permissions.length
                    ? row.permissions.map((p, i) => {
                          let splitArray = p.split(".");
                          return <Chip key={i} style={{ backgroundColor: "#657380", color: "white" }} label={p} icon={"pi pi-" + (splitArray[1] === "READ" ? "eye" : "pencil")} className="mr-2 mb-2" />;
                      })
                    : null}
            </div>
        );
    };

    const onAddUser = () => {
        setDialogDisplay(true);
    };

    const showActionButtons = (row) => {
        return (
            <div>
                <Button icon="pi pi-user-edit" className="p-button-rounded mr-2 mb-2" onClick={(e) => onEditClick(row)} tooltip="Edit" tooltipOptions={{ position: "bottom" }} />
                {row.user.userVerified !== undefined && row.user.userVerified != null && !row.user.userVerified && <Button icon="pi pi-envelope" className="p-button-rounded mr-2 mb-2" onClick={(e) => onResendInviteUser(row)} tooltip="Re-invite" tooltipOptions={{ position: "bottom" }} />}
                <Button icon="pi pi-trash" className="p-button-rounded mr-2 mb-2" onClick={(e) => onDeleteClick(row)} tooltip="Delete" tooltipOptions={{ position: "bottom" }} />
            </div>
        );
    };

    const onEditClick = (e) => {
        setDialogDisplay(true);
        setSelectedUser(e);
    };

    const onDeleteClick = (e) => {
        setSelectedUser(e);

        if (e.user.role === "ihdesigner") {
            const hasCustomer = customers.some((customer) => {
                return customer.designerID === e.user.email;
            });
            if (hasCustomer) {
                setAssignedCustomerWarningDialogVisible(true);
            } else {
                setDeleteWarningDialogVisible(true);
            }
        } else {
            setDeleteWarningDialogVisible(true);
        }
    };
    const onReset = (e) => {
        // reset filters
        setSearchText("");
        setSelectedUserType("");
        setNotVerifiedUser(false);
        setResetKey((prev) => prev + 1);
    };
    const onResendInviteUser = (e) => {
        setResendInviteDialogVisible(true);
        setSelectedUser(e);
    };
    const onSideBarHide = () => {
        setDialogDisplay(false);
        setSelectedUser(null);
    };

    const deleteUser = () => {
        const payload = {
            username: selectedUser.user.mobile,
        };
        tenantService
            .deleteUser(payload)
            .then((res) => {
                if (res) {
                    if (res.responseCode === 200) {
                        // toast.current.show({ summary: "Success", severity: "success", detail: "User deleted successfully" });
                        setDeletionSubmitted(true);
                        setTimeout(() => {
                            setDeleteWarningDialogVisible(false);
                            setSelectedUser(null);
                            onReset();
                        }, 5000);
                    } else {
                        toast.current.show({ summary: "Error", severity: "error", detail: res?.message ?? "User deletion failed" });
                    }
                }
            })
            .catch((e) => {
                toast.current.show({ summary: "Error", severity: "error", detail: e.response?.data?.message ?? "User deletion failed" });
                console.error(e);
            });
    };
    const inviteUser = () => {
        const payload = {
            username: selectedUser.user.mobile,
        };
        tenantService
            .resendInvitation(payload)
            .then((res) => {
                if (res) {
                    if (res.responseCode === 200) {
                        toast.current.show({ summary: "Success", severity: "success", detail: "Invitation sent successfully" });
                        setResendInviteDialogVisible(false);
                        setSelectedUser(null);
                        onReset();
                    } else {
                        toast.current.show({ summary: "Error", severity: "error", detail: res?.message ?? "Resending the invitation failed" });
                    }
                }
            })
            .catch((e) => {
                toast.current.show({ summary: "Error", severity: "error", detail: e.response?.data?.message ?? "Resending the invitation failed" });
                console.error(e);
            });
    };

    const deleteConfirmationDialogFooter = (
        <div className="grid w-full gap-3">
            <div className="col-12 md:col-6">
                <Button
                    label="No"
                    className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                    onClick={(e) => {
                        setDeleteWarningDialogVisible(false);
                        setSelectedUser(null);
                    }}
                />
            </div>
            <div className="col-12 md:col-6">
                <Button
                    label="Yes"
                    className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                    style={{
                        letterSpacing: "1.44px",
                        backgroundColor: "#9AAB89",
                        borderColor: "#9AAB89",
                    }}
                    onClick={deleteUser}
                />
            </div>
        </div>
    );

    const assignCustWarningDialogFooter = (
        <>
            <Button
                label="OK"
                className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color"
                style={{
                    letterSpacing: "1.44px",
                    padding: "10px 30px",
                    backgroundColor: "#9AAB89",
                    borderColor: "#9AAB89",
                }}
                onClick={() => {
                    setAssignedCustomerWarningDialogVisible(false);
                    setSelectedUser(null);
                }}
            />
        </>
    );

    const resendInviteConfirmationDialogFooter = (
        <div className="grid w-full gap-3">
            <div className="col-12 md:col-6">
                <Button
                    label="No"
                    className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                    onClick={(e) => {
                        setResendInviteDialogVisible(false);
                        setSelectedUser(null);
                    }}
                />
            </div>
            <div className="col-12 md:col-6">
                <Button
                    label="Yes"
                    className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                    style={{
                        letterSpacing: "1.44px",
                        backgroundColor: "#9AAB89",
                        borderColor: "#9AAB89",
                    }}
                    onClick={inviteUser}
                />
            </div>
        </div>
    );

    const getUserRole = (user) => {
        if (!user?.role) return "--";

        if (user.role === "ihdesigner") {
            return user.userType === "brandAmbassador" ? "Designer (Brand Ambassador)" : "Designer";
        }
        if (user.role === "ihcustomer") return "Customer";

        return "--";
    };

    const onSuccess = (dialogDisplay, msg) => {
        if (msg) toast.current.show({ severity: "success", summary: "Success", detail: msg });
        setDialogDisplay(dialogDisplay);
        setSelectedUser(null);
        // reset filters
        onReset();
    };

    const handleUnverifiedToggle = (e) => {
        const checked = e.target.checked;
        setNotVerifiedUser(checked);
    };
    const onDownload = async () => {
        // Apply filters from UI
        let resp = await tenantService.getUsers(makeQuery());

        if (resp.responseCode !== 200) {
            message?.current?.show({ severity: "error", content: "Something went wrong" });
            return;
        }
        if (resp.responseData.length) {
            const data = resp.responseData.map((item) => ({
                Name: item.user?.name || "",
                Email: item.user?.email || "",
                Mobile: item.user?.mobile || "",
                "Module Access": item.permissions?.join(", ") || "",
            }));
            let filename = "Webapp Users.xlsx";
            let ws = XLSX.utils.json_to_sheet(data);
            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        } else {
            toast.current.show({ summary: "Error", severity: "error", detail: "No data to download" });
        }
    };

    return (
        <div className="grid">
            <div className="col-12">
                <Toast ref={toast} />
                <div className="grid">
                    <div className="col-12">
                        <div className="w-full flex justify-content-between align-items-center">
                            <h3 className="font-larken m-0 charcoal-color">{"All Users"} </h3>
                            <Button label="Add User" icon="pi pi-user-plus" style={{ borderRadius: "12px" }} className="mr-2 mb-2 p-button-rounded sage-ivory" onClick={() => onAddUser()}></Button>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="col-12">
                            <div className="manage-users-filters">
                                <div className="filter-item">
                                    <InputText
                                        className="h-3rem border-primary-500 w-full"
                                        placeholder="Search"
                                        value={searchText}
                                        suffix={searchText && <i className="pi pi-times cursor-pointer" style={{ color: "black" }} onClick={() => setSearchText("")} />}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        style={{
                                            borderRadius: "1.25rem",
                                            border: "1px solid rgba(116, 120, 141, 0.20)",
                                            background: "#FAFAFA",
                                        }}
                                    />
                                </div>
                                <div className="filter-item">
                                    <Dropdown
                                        value={selectedUserType}
                                        options={userTypeOptions}
                                        onChange={(e) => setSelectedUserType(e.value)}
                                        placeholder="User Type"
                                        className="h-3rem w-full"
                                        style={{
                                            borderRadius: "1.25rem",
                                            border: "1px solid rgba(116, 120, 141, 0.20)",
                                            background: "#FAFAFA",
                                        }}
                                    />
                                </div>
                                <div className="filter-item filter-checkbox">
                                    <Checkbox inputId="notverified" name="notverified" value={notVerifiedUser} checked={notVerifiedUser} onChange={handleUnverifiedToggle} />
                                    <label htmlFor="notverified">Not Verified</label>
                                </div>

                                <div className="filter-actions">
                                    <Button
                                        icon="pi pi-refresh"
                                        label="Reset"
                                        className=" p-button-rounded"
                                        style={{ borderRadius: "12px", minWidth: "6rem", height: "2.5rem", backgroundColor: "#BFAD5B" }}
                                        onClick={(e) => {
                                            e.currentTarget.blur();
                                            onReset();
                                        }}
                                    />
                                    <Button icon="pi pi-download" label="Download" className="p-button-rounded sage-ivory" style={{ borderRadius: "12px", minWidth: "6rem", height: "2.5rem" }} onClick={onDownload} />
                                </div>
                            </div>
                        </div>

                        <DataTable
                            value={users}
                            first={first}
                            rows={rows}
                            onPage={async (e) => {
                                const totalPages = Math.ceil(users.length / rows);
                                if (e.page === totalPages - 1 && skip !== -1) {
                                    const newSkip = users.length;
                                    setSkip(newSkip);
                                    await handleFilter(newSkip);
                                }
                                setFirst(e.first);
                            }}
                            loading={loading}
                            paginator
                            responsiveLayout="scroll"
                            showGridlines
                        >
                            <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" style={{ width: "100px" }} header="Image" body={imageBodyTemplate}></Column>
                            <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="User Name" style={{ width: "100px" }} field="user.name"></Column>
                            <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="Email" style={{ width: "100px" }} field="user.email"></Column>
                            <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="Mobile" style={{ width: "150px" }} field="user.mobile"></Column>
                            <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="Trade Partner" style={{ width: "150px" }} field="user.org.orgLegalName" body={(raw)=>{
                                return raw.user?.org?.orgLegalName || '--'
                            }}></Column>
                            <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="User Role" style={{ width: "150px" }} body={(rowData) => getUserRole(rowData.user)}></Column>
                            {/* <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="Module access" style={{ width: "150px" }} body={showPermissions}></Column> */}
                            {serviceData.serviceTypeName === "Toll Dashboard" && <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="Role" style={{ width: "150px" }} field="user.role"></Column>}
                            {/* <Column headerClassName='dtHeaderStyle' bodyClassName="bodyStyle" header="Location Access" field="loc"></Column> */}
                            {writeAccess ? <Column headerClassName="dtHeaderStyle" bodyClassName="bodyStyle" header="Action" body={showActionButtons}></Column> : null}
                        </DataTable>
                    </div>
                </div>
                <Sidebar visible={displayDailog} style={{ width: "50vh" }} onHide={() => onSideBarHide()} baseZIndex={1000} position="right">
                    <h5>{(selectedUser ? "Edit" : "Invite") + " User"}</h5>
                    <hr />
                    {displayDailog ? <InviteUser tradePartners={tradePartners} selectedUser={selectedUser} allVendors={allVendors} onSuccess={(dialogDisplay, msg) => onSuccess(dialogDisplay, msg)} countryList={countryList} /> : null}
                </Sidebar>

                {displayDeleteWarningDialog && (
                    <Dialog
                        header={<h3 className="m-0 font-light font-larken">Delete User</h3>}
                        style={{
                            width: "90vw",
                            maxWidth: "35rem",
                            color: "#1D1B1C",
                            fontFamily: "Gerstner-ProgramRegular",
                        }}
                        breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                        visible={displayDeleteWarningDialog}
                        onHide={() => {
                            setDeleteWarningDialogVisible(false);
                            setDeletionSubmitted(false); // reset on close
                        }}
                        modal
                        closable={!deletionSubmitted}
                        draggable={false}
                        footer={deletionSubmitted ? null : deleteConfirmationDialogFooter}
                    >
                        {!deletionSubmitted ? (
                            <div className="flex align-items-center mt-3 text-base md:text-lg justify-content-center">
                                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "1.8rem", color: "#f0ad4e" }} />
                                <span>
                                    Are you sure you want to delete the user with email ID <b>{selectedUser.user.email}</b>?
                                </span>
                            </div>
                        ) : (
                            <div className="font-Gerstner-ProgramRegular p-3 text-center">
                                <i className="pi pi-check-circle mb-3" style={{ fontSize: "1.8rem", color: "green" }} />
                                <p className="m-0">Your request has been submitted for processing. The deletion process will take a while. Please check after some time.</p>
                            </div>
                        )}
                    </Dialog>
                )}
                {assignedCustomerWarningDialog && (
                    <Dialog
                        header={<h3 className="m-0 font-light font-larken">Delete User</h3>}
                        style={{
                            width: "90vw",
                            maxWidth: "35rem",
                            color: "#1D1B1C",
                            fontFamily: "Gerstner-ProgramRegular",
                        }}
                        breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                        draggable={false}
                        visible={assignedCustomerWarningDialog}
                        onHide={() => setAssignedCustomerWarningDialogVisible(false)}
                        modal
                        footer={assignCustWarningDialogFooter}
                    >
                        <div className="flex align-items-center mt-3 text-base md:text-lg justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "1.8rem", color: "#f0ad4e" }} />
                            <span>
                                User <b>{selectedUser.user.email}</b> is currently assigned to one or more customers. Please reassign them before proceeding with deletion.
                            </span>
                        </div>
                    </Dialog>
                )}

                {displayResendInviteDialog && (
                    <Dialog
                        header={<h3 className="m-0 font-light font-larken">Resend Invite</h3>}
                        style={{
                            width: "90vw",
                            maxWidth: "35rem",
                            color: "#1D1B1C",
                            fontFamily: "Gerstner-ProgramRegular",
                        }}
                        breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                        draggable={false}
                        visible={displayResendInviteDialog}
                        onHide={() => setResendInviteDialogVisible(false)}
                        modal
                        footer={resendInviteConfirmationDialogFooter}
                    >
                        <div className="flex align-items-center mt-3 text-base md:text-lg justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "1.8rem", color: "#f0ad4e" }} />
                            <span>
                                Are you sure you want to resend the invitation to the user with email id <b>{selectedUser.user.email}</b>?
                            </span>
                        </div>
                    </Dialog>
                )}
            </div>
        </div>
    );
};
export default ManageUsers;
